import React from 'react'

/**
 * @param {Object} props - The props
 * @param {String} props.description - The content description
 * @returns {JSX.Element} DetailPageV3Description
 */

const DetailPageV3Description = (props) => {
  const {
    description,
  } = props

  return (
    <div className="detail-page-v3__description">
      {description}
    </div>
  )
}

export default DetailPageV3Description
